// export const getFlightTravelDetails = (tripData: any[]) => {
//   function filterValidFlights(flights: any[]) {
//     if (!Array.isArray(flights) || flights.length === 0) {
//       return []; // Return an empty array if the input is invalid
//     }

//     return flights.filter((flight) => {
//       return (
//         flight.departure_city_name &&
//         // flight.departure_city_state &&
//         // flight.departure_city_country &&
//         // flight.departure_city_country_code &&
//         // flight.departure_city_latitude &&
//         // flight.departure_city_longitude &&
//         flight.arrival_city_name
//         // &&
//         // flight.arrival_city_state &&
//         // flight.arrival_city_country &&
//         // flight.arrival_city_country_code &&
//         // flight.arrival_city_latitude &&
//         // flight.arrival_city_longitude
//       );
//     });
//   }
//   if (!tripData || tripData.length === 0) {
//     return [];
//   }
//   const travelDetails: any[] = [];

//   tripData.forEach((trip) => {
//     // Count the number of days in the city
//     const numberOfDays = trip?.tripDetails?.length || 0;

//     // Collect flight details for the city
//     const flights: any = [];
//     trip?.tripDetails?.forEach((day: any) => {
//       const dateInfo = day?.date;
//       const dayFlights = day?.itinerary_by_time_of_the_day_data?.filter(
//         (activity: any) =>
//           activity?.activity_type?.toLowerCase?.() ===
//           "transportation.flight".toLowerCase?.()
//       );

//       const filterFlights = filterValidFlights(dayFlights);
//       filterFlights?.forEach((flight: any) => {
//         flights.push({
//           // departure_city_name:
//           //   flight?.departure_city_name && flight?.departure_city_country
//           //     ? `${flight.departure_city_name}, ${flight?.departure_city_state}, ${flight.departure_city_country}`
//           //     : flight?.departure_city_name ||
//           //       flight?.departure_city_country ||
//           //       "",
//           dateInfo,
//           departure_city_name: [
//             flight?.departure_city_name,
//             flight?.departure_city_state,
//             flight?.departure_city_country,
//           ]
//             .filter(Boolean)
//             .join(", "),
//           departure_city_latitude:
//             flight?.departure_city_latitude ||
//             flight?.departure_city_latitude ||
//             "",
//           departure_city_longitude: flight?.departure_city_longitude || "",
//           departure_city_country_code:
//             flight?.departure_city_country_code || "",
//           time_of_the_day: flight?.time_of_the_day || "",

//           // arrival_city_name:
//           //   flight?.arrival_city_name && flight?.arrival_city_country
//           //     ? `${flight.arrival_city_name}, ${flight?.arrival_city_state}, ${flight.arrival_city_country}`
//           //     : flight?.arrival_city_name ||
//           //       flight?.arrival_city_country ||
//           //       "",
//           arrival_city_name: [
//             flight?.arrival_city_name,
//             flight?.arrival_city_state,
//             flight?.arrival_city_country,
//           ]
//             .filter(Boolean)
//             .join(", "),
//           arrival_city_country_code: flight?.arrival_city_country_code || "",
//           arrival_city_latitude:
//             flight?.arrival_city_latitude ||
//             flight?.arrival_city_latitude ||
//             "",
//           arrival_city_longitude: flight?.arrival_city_longitude || "",
//         });
//       });
//     });

//     // Add the city details with number of days and flights
//     travelDetails.push({
//       city_name: trip?.city_name || "",
//       number_of_days: numberOfDays,
//       flights: flights,
//     });
//   });
//   return travelDetails;
// };

// export const getFlightTravelDetails = (tripData: any[]) => {
//   // Function to normalize flight data
//   function normalizeFlightData(flight: any, dateInfo: string) {
//     return {
//       dateInfo: dateInfo || "",
//       departure_city_name: [
//         flight?.departure_city_name,
//         flight?.departure_city_state,
//         flight?.departure_city_country,
//       ]
//         .filter(Boolean)
//         .join(", "),
//       departure_city_latitude: flight?.departure_city_latitude || "",
//       departure_city_longitude: flight?.departure_city_longitude || "",
//       departure_city_country_code: flight?.departure_city_country_code || "",
//       time_of_the_day: flight?.time_of_the_day || "",
//       arrival_city_name: [
//         flight?.arrival_city_name,
//         flight?.arrival_city_state,
//         flight?.arrival_city_country,
//       ]
//         .filter(Boolean)
//         .join(", "),
//       arrival_city_country_code: flight?.arrival_city_country_code || "",
//       arrival_city_latitude: flight?.arrival_city_latitude || "",
//       arrival_city_longitude: flight?.arrival_city_longitude || "",
//     };
//   }

//   // Return an empty array if tripData is invalid or empty
//   if (!tripData || tripData.length === 0) {
//     return [];
//   }

//   const travelDetails: any[] = [];

//   // Iterate over each trip in tripData
//   tripData.forEach((trip) => {
//     // const numberOfDays = trip?.tripDetails?.length || 0;
//     const numberOfDays = trip?.tripDetails?.reduce((max: number, day: any) => {
//       const dayNumber = parseInt(day?.day?.replace("Day ", "")) || 0;
//       return Math.max(max, dayNumber);
//     }, 0);
//     const flights: any[] = [];

//     // Iterate over each day in tripDetails
//     trip?.tripDetails?.forEach((day: any) => {
//       const dateInfo = day?.date;
//       const dayFlights = day?.itinerary_by_time_of_the_day_data?.filter(
//         (activity: any) =>
//           activity?.activity_type?.toLowerCase?.() ===
//           "transportation.flight".toLowerCase?.()
//       );

//       // Normalize and collect flight data for the day
//       if (dayFlights?.length) {
//         dayFlights.forEach((flight: any) => {
//           flights.push(normalizeFlightData(flight, dateInfo));
//         });
//       }
//     });

//     // If no flights found, check if any itinerary contains "transportation.flight"
//     if (flights.length === 0) {
//       const hasFlightActivity = trip?.tripDetails?.some((day: any) =>
//         day?.itinerary_by_time_of_the_day?.some(
//           (activity: any) =>
//             activity?.activity_type?.toLowerCase?.() ===
//             "transportation.flight".toLowerCase?.()
//         )
//       );

//       // Add a placeholder flight data if flight activity is found
//       if (hasFlightActivity) {
//         flights.push(normalizeFlightData({}, trip?.tripDetails[0]?.date || ""));
//       }
//     }

//     // Add the city details with number of days and flights
//     travelDetails.push({
//       city_name: trip?.city_name || "",
//       number_of_days: numberOfDays,
//       flights: flights,
//     });
//   });

//   return travelDetails;
// };

// export const getFlightTravelDetails = (tripData: any[]) => {
//   // Function to normalize flight data
//   function normalizeFlightData(flight: any, dateInfo: string) {
//     return {
//       dateInfo: dateInfo || "",
//       departure_city_name: [
//         flight?.departure_city_name,
//         flight?.departure_city_state,
//         flight?.departure_city_country,
//       ]
//         .filter(Boolean)
//         .join(", "),
//       departure_city_latitude: flight?.departure_city_latitude || "",
//       departure_city_longitude: flight?.departure_city_longitude || "",
//       departure_city_country_code: flight?.departure_city_country_code || "",
//       time_of_the_day: flight?.time_of_the_day || "",
//       arrival_city_name: [
//         flight?.arrival_city_name,
//         flight?.arrival_city_state,
//         flight?.arrival_city_country,
//       ]
//         .filter(Boolean)
//         .join(", "),
//       arrival_city_country_code: flight?.arrival_city_country_code || "",
//       arrival_city_latitude: flight?.arrival_city_latitude || "",
//       arrival_city_longitude: flight?.arrival_city_longitude || "",
//     };
//   }

//   // Return an empty array if tripData is invalid or empty
//   if (!tripData || tripData.length === 0) {
//     return [];
//   }

//   const travelDetails: any[] = [];

//   // Iterate over each trip in tripData
//   tripData.forEach((trip) => {
//     let latestFlightDay = 0;
//     const flights: any[] = [];

//     // Iterate over each day in tripDetails
//     trip?.tripDetails?.forEach((day: any) => {
//       const dateInfo = day?.date;
//       const dayNumber = parseInt(day?.day?.replace("Day ", "")) || 0; // Extract day number

//       const dayFlights = day?.itinerary_by_time_of_the_day_data?.filter(
//         (activity: any) =>
//           activity?.activity_type?.toLowerCase?.() ===
//           "transportation.flight".toLowerCase?.()
//       );

//       // Normalize and collect flight data for the day
//       if (dayFlights?.length) {
//         dayFlights.forEach((flight: any) => {
//           flights.push(normalizeFlightData(flight, dateInfo));
//         });

//         // Update the latest day that has a flight
//         latestFlightDay = Math.max(latestFlightDay, dayNumber);
//       }
//     });

//     // If no flights found, check if any itinerary contains "transportation.flight"
//     if (flights.length === 0) {
//       const firstDay = trip?.tripDetails?.[0];
//       const hasFlightActivity = trip?.tripDetails?.some((day: any) =>
//         day?.itinerary_by_time_of_the_day?.some(
//           (activity: any) =>
//             activity?.activity_type?.toLowerCase?.() ===
//             "transportation.flight".toLowerCase?.()
//         )
//       );

//       // Add a placeholder flight data if flight activity is found
//       if (hasFlightActivity) {
//         flights.push(normalizeFlightData({}, firstDay?.date || ""));
//         latestFlightDay = parseInt(firstDay?.day?.replace("Day ", "")) || 1; // Default to day 1
//       }
//     }

//     // Add the city details with number of days (latest day with a flight)
//     travelDetails.push({
//       city_name: trip?.city_name || "",
//       number_of_days: latestFlightDay, // Updated logic to consider flight days
//       flights: flights,
//     });
//   });

//   return travelDetails;
// };

export const getFlightTravelDetails = (tripData: any[]) => {
  // Function to normalize flight data
  function normalizeFlightData(flight: any, dateInfo: string, departureDay: number) {
    return {
      dateInfo: dateInfo || "",
      departureDay: departureDay || 0,
      departure_city_name: [flight?.departure_city_name, flight?.departure_city_state, flight?.departure_city_country]
        .filter(Boolean)
        .join(", "),
      departure_city_latitude: flight?.departure_city_latitude || "",
      departure_city_longitude: flight?.departure_city_longitude || "",
      departure_city_country_code: flight?.departure_city_country_code || "",
      time_of_the_day: flight?.time_of_the_day || "",
      arrival_city_name: [flight?.arrival_city_name, flight?.arrival_city_state, flight?.arrival_city_country]
        .filter(Boolean)
        .join(", "),
      arrival_city_country_code: flight?.arrival_city_country_code || "",
      arrival_city_latitude: flight?.arrival_city_latitude || "",
      arrival_city_longitude: flight?.arrival_city_longitude || "",
    };
  }

  // Return an empty array if tripData is invalid or empty
  if (!tripData || tripData.length === 0) {
    return [];
  }

  const travelDetails: any[] = [];

  // Iterate over each trip in tripData
  tripData.forEach((trip) => {
    let latestFlightDay = 0;
    const flights: any[] = [];

    // Iterate over each day in tripDetails
    trip?.tripDetails?.forEach((day: any) => {
      const dateInfo = day?.date;
      const dayNumber = parseInt(day?.day?.replace("Day ", "")) || 0; // Extract day number
      const dayFlights = day?.itinerary_by_time_of_the_day_data?.filter(
        (activity: any) => activity?.activity_type?.toLowerCase?.() === "transportation.flight".toLowerCase?.()
      );

      // Normalize and collect flight data for the day
      if (dayFlights?.length) {
        dayFlights.forEach((flight: any) => {
          flights.push(normalizeFlightData(flight, dateInfo, dayNumber));
        });

        // Update the latest day that has a flight
        latestFlightDay = Math.max(latestFlightDay, dayNumber);
      }
    });

    // If no flights found, check if any itinerary contains "transportation.flight"
    if (flights.length === 0) {
      const firstDay = trip?.tripDetails?.[0];
      const hasFlightActivity = trip?.tripDetails?.some((day: any) =>
        day?.itinerary_by_time_of_the_day?.some(
          (activity: any) => activity?.activity_type?.toLowerCase?.() === "transportation.flight".toLowerCase?.()
        )
      );

      // Add a placeholder flight data if flight activity is found
      if (hasFlightActivity) {
        const firstDayNumber = parseInt(firstDay?.day?.replace("Day ", "")) || 1; // Default to day 1
        flights.push(normalizeFlightData({}, firstDay?.date || "", firstDayNumber));
        latestFlightDay = firstDayNumber;
      }
    }

    // Add the city details with number of days (latest day with a flight)
    travelDetails.push({
      city_name: trip?.city_name || "",
      number_of_days: latestFlightDay, // Updated logic to consider flight days
      flights: flights,
    });
  });

  return travelDetails;
};
